import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../Navigation';
import Footer from '../Footer';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page bg-background min-h-screen">
      <Navigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Privacy{' '}
            <span className="bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] bg-clip-text text-transparent">
              Policy
            </span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            We take your privacy seriously. Learn how we collect, use, and protect your information.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-1">
            <div className="bg-gradient-to-br from-[#FF56A5]/20 via-[#E852FF]/20 to-[#9F44F2]/20 rounded-2xl p-8">
              <div className="space-y-8 text-gray-300">
                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">1. Introduction</h2>
                  <p>
                    At Lifelike Agents, we take your privacy seriously. This Privacy Policy explains how we collect,
                    use, disclose, and safeguard your information when you use our AI communication platform.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">2. Information We Collect</h2>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">2.1 Personal Information:</h3>
                      <ul className="list-disc ml-6 space-y-2">
                        <li>Name and contact information</li>
                        <li>Account credentials</li>
                        <li>Payment information</li>
                        <li>Communication preferences</li>
                      </ul>
                    </div>
                    
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">2.2 Usage Information:</h3>
                      <ul className="list-disc ml-6 space-y-2">
                        <li>Interaction with our services</li>
                        <li>Call logs and recordings</li>
                        <li>AI conversation data</li>
                        <li>Technical data and analytics</li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">3. How We Use Your Information</h2>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>To provide and maintain our services</li>
                    <li>To improve and personalize user experience</li>
                    <li>To process payments and transactions</li>
                    <li>To communicate with you about our services</li>
                    <li>To comply with legal obligations</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">4. Data Security</h2>
                  <p>
                    We implement appropriate technical and organizational measures to protect your personal
                    information against unauthorized access, alteration, disclosure, or destruction.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">5. Your Rights</h2>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Access your personal information</li>
                    <li>Correct inaccurate data</li>
                    <li>Request deletion of your data</li>
                    <li>Object to data processing</li>
                    <li>Data portability</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">6. Contact Us</h2>
                  <p>
                    If you have any questions about this Privacy Policy, please contact us at:{' '}
                    <a href="mailto:privacy@lifelikeagents.com" className="text-[#E852FF] hover:text-[#FF56A5] transition-colors">
                      privacy@lifelikeagents.com
                    </a>
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">7. Updates to This Policy</h2>
                  <p>
                    We may update this Privacy Policy from time to time. We will notify you of any changes by
                    posting the new Privacy Policy on this page and updating the "Last Updated" date.
                  </p>
                </section>

                <div className="mt-8 pt-8 border-t border-white/10">
                  <p className="text-gray-400 text-sm">
                    Last Updated: February 19, 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy; 